import 'focus-visible';
import 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange'; // tslint:disable-line
import 'lazysizes/plugins/respimg/ls.respimg'; // tslint:disable-line
import 'lazysizes/plugins/rias/ls.rias'; // tslint:disable-line

import '../../styles/theme.pcss';

import {Accordion} from '../ui/accordion';
// import {Cart} from '../ui/cart';
// import {CartLink} from '../ui/cart-link';
// import '../ui/cart-link/cart-link.pcss';
import {CookieConsent} from '../ui/cookie-consent';
import {Dropdown} from '../ui/dropdown';
import '../ui/dropdown/dropdown.pcss';
import {MessageGroup} from '../ui/message-group';
import {Newsletter} from '../ui/newsletter';
import '../ui/navigation-megamenu/navigation-megamenu-cta.pcss';
import '../ui/navigation-megamenu/navigation-megamenu-feature.pcss';
import '../ui/navigation-megamenu/navigation-megamenu-region.pcss';
import '../ui/navigation-megamenu/navigation-megamenu.pcss';
import {PlusMinus} from '../ui/plus-minus';
import '../ui/plus-minus/plus-minus.pcss';
import {SearchBox, SearchBoxElement} from '../ui/search-box';
import '../ui/search-box/search-box.pcss';
import {TopBarCTA} from '../ui/top-bar-cta';
import {TradeBar} from '../ui/trade-bar';
import {Usp} from '../ui/usp-banner';
import {cookiesEnabled, createCookie, mountReact, ready} from '../utils';

if (!cookiesEnabled()) {
  document.documentElement.className = document.documentElement.className.replace(
    'supports-cookies',
    'supports-no-cookies',
  );
}

const storeUrl = new URL(location.href);
const storeCountry = storeUrl.host.split('.')[0];
if (storeUrl.searchParams.has('locale_override')) {
  createCookie('t21_store_pref', storeCountry, 0.5, {
    parentDomain: true,
    secure: true,
  });
  createCookie('t21_redirect_store', 'true', 0.5, {
    parentDomain: true,
    secure: true,
  });
}

const footerAccordion = document.getElementById(
  'footerAccordion',
) as HTMLElement;
if (footerAccordion) {
  new Accordion(footerAccordion, {});
}

const footerNewsletter = document.getElementById('newsletter') as HTMLElement;
if (footerNewsletter) {
  new Newsletter(footerNewsletter, {});
}

const uspBanner = document.getElementById('usp-banner') as HTMLElement;
new Usp(uspBanner);

const topBarCta = document.getElementById('top-bar-cta') as HTMLElement;
new TopBarCTA(topBarCta);

const searchBox = document.querySelector(
  '[data-searchbox]',
) as SearchBoxElement;
if (searchBox) {
  new SearchBox(searchBox);
}

const accountDropdownToggle = document.querySelector(
  '.account-dropdown [data-dropdown-toggle]',
);
if (accountDropdownToggle) {
  accountDropdownToggle.addEventListener('click', () => {
    document.documentElement.dispatchEvent(
      new CustomEvent('close-nav', {bubbles: true}),
    );
  });
}

// Array.from(document.querySelectorAll(CartLink.defaults.selector)).map(
//   item => new CartLink(item as HTMLElement),
// );

Array.from(document.querySelectorAll(Dropdown.defaults.selector)).map(
  item => new Dropdown(item as HTMLElement),
);

Array.from(document.querySelectorAll(PlusMinus.defaults.selector)).map(
  item => new PlusMinus(item as HTMLElement),
);

const cookieConsent = document.querySelector('[data-cookie-consent]');

if (cookieConsent) {
  new CookieConsent(cookieConsent as HTMLElement);
}

mountReact('#message-group', MessageGroup);
mountReact('#trade-bar', TradeBar);
// mountReact('#mini-cart', Cart);

/**
 * DOM loaded decorator for animation fix
 */
const removePreload = () => document.body.classList.remove('preload');

ready(removePreload);

/**
 * Decorate lazy load parents
 * @param {Event} event
 */
function decorateLazyParent(event: Event) {
  const target = event.target as HTMLElement;
  const wrapper = target.closest('.responsive-image__wrapper');

  if (!wrapper) {
    return;
  }

  wrapper.classList.add('has-loaded');
}

document.addEventListener('lazyloaded', decorateLazyParent);

declare global {
  interface Window {
    Shopify: any;
    theme: {
      moneyFormat: string;
    };
  }
}
